import React from "react";
import PropTypes from "prop-types";
import { H6, Checkbox, Small } from "orcs-design-system";

const FilterSearchSection = (props) => {
  const { items, onChange, checkedItems = [] } = props;

  return (
    <>
      <H6 fontWeight="bold" mt="s">
        Filter results by:
      </H6>
      <Small color="greyDark" display="block">
        Selecting filters below will refine your search to only show results
        matching one (or more) of the following fields.
      </Small>
      {items &&
        items.map((item) => {
          return (
            <Checkbox
              key={item.name}
              label={item.label}
              name={item.name}
              checked={checkedItems.includes(item.name)}
              onChange={onChange}
            />
          );
        })}
    </>
  );
};

FilterSearchSection.propTypes = {
  items: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  checkedItems: PropTypes.array,
};

export default FilterSearchSection;
